const YouTube = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20.893,6.73a2.547,2.547,0,0,0-1.792-1.8C17.521,4.5,11.183,4.5,11.183,4.5s-6.338,0-7.918.426a2.547,2.547,0,0,0-1.792,1.8,26.714,26.714,0,0,0-.423,4.91,26.714,26.714,0,0,0,.423,4.91,2.509,2.509,0,0,0,1.792,1.775c1.581.426,7.918.426,7.918.426s6.338,0,7.918-.426a2.509,2.509,0,0,0,1.792-1.775,26.714,26.714,0,0,0,.423-4.91,26.714,26.714,0,0,0-.423-4.91ZM9.111,14.653V8.626l5.3,3.013-5.3,3.013Z"
            transform="translate(0.817 0.375)"
            fill="currentColor"/>
    </svg>
  )
}

export default YouTube
